module.exports = __webpack_public_path__ + "img/illustration.c1a024a0.svg";